import spartaEventsUtility from "utilities/global/sparta-events-utility/2.3.2/js/sparta-events-utility";
import spartaStoreUtility from "utilities/global/sparta-store-utility/3.0.3/js/sparta-store-utility";
import _ from "utilities/vendor/lodash/4.13.1/js/lodash.custom.min";
import * as CommonBrowserUtils from "utilities/community/common-browser-utils/1.0.0/js/common-browser-utils";
import spartaMediaQueryConstantsUtility from "utilities/global/sparta-mediaquery-constants-utility/1.1.0/js/sparta-mediaquery-constants-utility";





const getPrefixedPixelRatio = () => {

  const elem = document.createElement('sparta');


  const prefixes = {
    webkitTransform: '-webkit-min-device-pixel-ratio: 2',
    MozTransform: 'min--moz-device-pixel-ratio: 2',
    oTransform: '-o-min-device-pixel-ratio: 2/1',
  };


  let result = 'min-device-pixel-ratio: 2';


  Object.keys(prefixes).some(prefix => {

    if (elem.style[prefix] !== undefined) {

      result = prefixes[prefix];


      return true;
    }

    return false;
  });


  return result;
};

export {
  getPrefixedPixelRatio,
};
